"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardModule = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var api_model_bear_1 = require("@gooddata/api-model-bear");
var util_1 = require("../util");
var export_1 = require("../utils/export");
var DashboardModule = /** @class */ (function () {
    function DashboardModule(xhr) {
        this.xhr = xhr;
    }
    DashboardModule.prototype.exportToPdf = function (projectId, dashboardUri, filters, pollingOptions) {
        if (filters === void 0) { filters = []; }
        if (pollingOptions === void 0) { pollingOptions = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sanitizedFilters, payload, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sanitizedFilters = api_model_bear_1.sanitizeFiltersForExport(filters);
                        payload = this.getDashboardExportPayload(dashboardUri, sanitizedFilters);
                        return [4 /*yield*/, this.xhr.post("/gdc/internal/projects/" + projectId + "/exportDashboard", { body: payload })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.pollPdfFile(response, pollingOptions)];
                }
            });
        });
    };
    DashboardModule.prototype.pollPdfFile = function (response, pollingOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                data = response.getData();
                return [2 /*return*/, util_1.handleHeadPolling(this.xhr.head.bind(this.xhr), data.uri, export_1.isExportFinished, pollingOptions)];
            });
        });
    };
    DashboardModule.prototype.getDashboardExportPayload = function (dashboardUri, filters) {
        if (filters.length) {
            return {
                dashboardExport: {
                    dashboardUri: dashboardUri,
                    filters: filters,
                },
            };
        }
        // minimize payload
        return {
            dashboardExport: {
                dashboardUri: dashboardUri,
            },
        };
    };
    return DashboardModule;
}());
exports.DashboardModule = DashboardModule;
//# sourceMappingURL=dashboard.js.map